import { JsonDiscriminatorValue, JsonObject } from "ta-json";

import DataType from "../data-type";
import { PropertyDefinition } from "../property-definition";

/**
 * Integer property definition.
 */
@JsonObject()
@JsonDiscriminatorValue(DataType.Integer)
export class IntegerPropertyDefinition extends PropertyDefinition {
    constructor(name: string, init?: Omit<Partial<IntegerPropertyDefinition>, "name">) {
        super(name, DataType.Integer);
        Object.assign(this, init);
    }
}
